module.exports = __webpack_public_path__ + "static/media/PhoneCallingV2.e081cef3.svg";